import React, { useState } from "react"
import {
  results,
  resultsTop,
  resultsContainer,
  resultItem,
  resultContent,
  resultType,
  resultTypeIcon,
  resultTypeType,
  resultTitle,
  resultMore,
  resultResume,
  listResult,
} from "./ResultsTaxo/listResults.module.scss"
import SummaryTransformer from "./Transformers/summary-transformer"
import Icon from "./Icon/icon"
import { summaryLength } from "../constants"
import PropTypes from "prop-types"
import { Infos } from "./ResultsTaxo/results-taxo-styled"
import {
  Article,
  ColoredIcon,
  Type,
} from "./ResultsTaxo/ResultItem/result-item-styled"
import TransitionFade from "./transition-fade"
import SearchFadeIn from "./search-fade-in"
import SearchFilters from "./search-filters"

//-----------------------Parent component---------------------------//
const SearchResults = ({ resultats, query }) => {
  const date = new Date()
  resultats = resultats.filter((result) => {
    if (result.field_affichage_planifie && result.field_date_de_publication) {
      if (result.field_date_de_depublication) {
        return (
          new Date(result.field_date_de_publication) <= date &&
          new Date(result.field_date_de_depublication) >= date
        )
      }
      return new Date(result.field_date_de_publication) <= date
    }
    return true
  })

  let tabType = []
  resultats.map((result) => {
    tabType.push(result.type)
    tabType = [...new Set(tabType)]
    return null
  })
  const [choosenType, setChoosenType] = useState(null)
  const toggleType = (typeChoisi, nameType) => {
    if (typeChoisi === nameType) {
      setChoosenType(null)
    } else {
      setChoosenType(nameType)
    }
  }

  if (choosenType !== null) {
    resultats = resultats.filter((result) => {
      if (result.type === choosenType) {
        return true
      }
      return false
    })
  }
  return (
    <section className={results}>
      <div className={resultsTop}>
        <Infos role="status" aria-live="polite">
          {resultats.length} résultat(s) pour le terme &quot;{query}&quot;
        </Infos>
      </div>
      <SearchFilters
        tabType={tabType}
        choosenType={choosenType}
        toggleType={toggleType}
      />
      <div className={resultsContainer}>
        {resultats.length === 0 && (
          <div>Pas de résultats, veuillez modifier votre requête</div>
        )}
        <SearchFadeIn delay={150}>
          <ul id="list-result" role="listbox" className={listResult}>
            {resultats.map((result, index) => {
              return <Result key={result.url} result={result} index={index} />
            })}
          </ul>
        </SearchFadeIn>
      </div>
    </section>
  )
}

//-----------------------Parent component---------------------------//

//-----------------------Child component---------------------------//

const Result = ({ result, index }) => {
  let iconType = ""
  let nodeType = ""
  switch (result.type) {
    case "node__carnet_d_adresse":
      iconType = "address-book"
      nodeType = "Carnet d'adresses"
      break
    case "node__actualites":
      iconType = "newspaper"
      nodeType = "Actualité"
      break
    case "node__evenements":
      iconType = "calendar"
      nodeType = "Evènement"
      break
    case "node__teleformulaires":
      iconType = "profile"
      nodeType = "Téléformulaire"
      break
    default:
      iconType = "file-empty"
      nodeType = "Page"
  }
  return (
    <li id={"item-" + index} role="option">
      <Article className={resultItem}>
        <TransitionFade link={result.url}>
          <div className={resultContent}>
            <Type className={resultType}>
              <Icon className={resultTypeIcon} size={20} icon={iconType} />
              <h3 className={resultTypeType}>{nodeType}</h3>
            </Type>
            <h4 className={resultTitle}>{result.title}</h4>
            {result.processed && (
              <p
                className={resultResume}
                dangerouslySetInnerHTML={{
                  __html: SummaryTransformer(result, summaryLength),
                }}
              />
            )}
          </div>
          <div className={resultMore}>
            <ColoredIcon size={30} icon="circle-right" />
          </div>
        </TransitionFade>
      </Article>
    </li>
  )
}

//-----------------------Child component---------------------------//

//-----------------------Styled component---------------------------//

//-----------------------Styled component---------------------------//

//-----------------------Prop-Types---------------------------//

SearchResults.propTypes = {
  resultats: PropTypes.array.isRequired,
  query: PropTypes.string.isRequired,
}
Result.propTypes = {
  result: PropTypes.object.isRequired,
  index: PropTypes.string.isRequired,
}

//-----------------------Prop-Types---------------------------//

export default SearchResults
